const ProjectActivitiesService = {
  url: `${process.env.VUE_APP_API_URL}project-activities`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },

  create: async (data) => {
    try {
      const headers = ProjectActivitiesService.headers;
      headers["Authorization"] = "Bearer " + localStorage.getItem("token");

      const response = await fetch(`${ProjectActivitiesService.url}`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: headers,
      });

      return response;
    } catch (e) {
      return false;
    }
  },
};

export default ProjectActivitiesService;
